/** The API uses 2000% of FTP as the open-ended power-zone sentinel. */
export function hasOpenPowerCeiling(maximum: number, savedFtp: number): boolean {
  return Number.isFinite(savedFtp) && savedFtp > 0
    && Number.isFinite(maximum) && Math.round(maximum) === Math.round(savedFtp * 20);
}


/** Shared axis in % FTP; the API's open-ended sentinel never sets its extent. */
export function powerZoneScale(zones: Array<{ minimum: number; maximum: number }>, ftp: number): number {
  if (!Number.isFinite(ftp) || ftp <= 0) return 150;
  const highest = zones.reduce((value, zone, index) => {
    const open = index === zones.length - 1 && hasOpenPowerCeiling(zone.maximum, ftp);
    return Math.max(value, (open ? zone.minimum / ftp * 100 + 25 : zone.maximum / ftp * 100));
  }, 150);
  return Math.ceil(highest / 25) * 25;
}

export function powerZoneSegment(minimum: number, maximum: number, ftp: number, scale: number, open: boolean) {
  const clamp = (value: number) => Math.min(100, Math.max(0, value));
  const start = ftp > 0 ? clamp(minimum / ftp * 100 / scale * 100) : 0;
  const end = open ? 100 : ftp > 0 ? clamp(maximum / ftp * 100 / scale * 100) : 0;
  return { start, width: Math.max(0, end - start) };
}


/** Integer-adjacent watt intervals share the previous ceiling as a display boundary. */
export function powerZonePercentRange(zones: Array<{ minimum: number; maximum: number }>, index: number, ftp: number) {
  if (!Number.isFinite(ftp) || ftp <= 0 || !zones[index]) return null;
  const zone = zones[index];
  const previous = zones[index - 1];
  const contiguous = previous && Number.isInteger(zone.minimum) && zone.minimum === previous.maximum + 1;
  const open = index === zones.length - 1 && hasOpenPowerCeiling(zone.maximum, ftp);
  const lowerBoundary = contiguous ? previous.maximum : open && Number.isInteger(zone.minimum) ? zone.minimum - 1 : zone.minimum;
  return { low: Math.round(lowerBoundary / ftp * 100), high: Math.round(zone.maximum / ftp * 100), open };
}
